import { Link, NavLink, Outlet } from 'react-router-dom'
import { useHubAuth } from '@/context/HubAuthContext'
import { cn } from '@/lib/utils'

const nav = [
  { to: '/hub', label: 'Dashboard', end: true },
  { to: '/hub/site', label: 'Site' },
  { to: '/hub/projects/new', label: 'New project' },
  { to: '/hub/evaluation', label: 'Evaluation' },
  { to: '/hub/messenger', label: 'Messenger' },
]

export default function HubLayout() {
  const { signOut } = useHubAuth()

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <header className="sticky top-0 z-10 border-b border-border bg-background/90 backdrop-blur">
        <div className="mx-auto flex h-12 max-w-6xl items-center justify-between gap-4 px-4">
          <div className="flex items-center gap-4 overflow-x-auto">
            <Link to="/hub" className="shrink-0 font-mono text-xs text-muted-foreground hover:text-foreground">
              Project Hub
            </Link>
            <nav className="flex shrink-0 gap-1">
              {nav.map(({ to, label, end }) => (
                <NavLink
                  key={to}
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    cn(
                      'whitespace-nowrap rounded-md px-2.5 py-1 text-xs font-medium transition',
                      isActive ? 'bg-muted text-foreground' : 'text-muted-foreground hover:text-foreground'
                    )
                  }
                >
                  {label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex shrink-0 items-center gap-3">
            <Link to="/" className="text-xs text-muted-foreground hover:text-foreground">
              Site
            </Link>
            <button type="button" onClick={() => signOut()} className="text-xs text-muted-foreground hover:text-foreground">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
